import { Link } from "react-router-dom";
import { MapPin, Star } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { getImageUrl } from "@/lib/imageUtils";

export default function ItemCard({ item }) {
  return (
    <Link to={`/items/${item.id}`} className="group block" data-testid={`item-card-${item.id}`}>
      <div className="rounded-2xl overflow-hidden border border-stone-200 bg-white hover:shadow-lg hover:-translate-y-1 transition-all duration-300 ease-out">
        <div className="aspect-[4/3] overflow-hidden relative">
          <img
            src={getImageUrl(item.images?.[0]) || "https://images.unsplash.com/photo-1604839379219-6871b4d4a4a5?w=400"}
            alt={item.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <Badge className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm text-stone-900 border-0 shadow-md rounded-full px-3 py-1 font-semibold text-xs">
            ${item.price_per_day}/day
          </Badge>
        </div>
        <div className="p-4">
          <div className="flex items-center gap-1 text-stone-500 text-xs mb-1">
            <MapPin className="w-3 h-3" />
            <span>{item.location}</span>
          </div>
          <h3 className="font-heading font-semibold text-stone-900 line-clamp-1 text-sm">
            {item.title}
          </h3>
          <div className="flex items-center justify-between mt-2">
            <span className="text-xs text-stone-500 bg-stone-100 px-2 py-0.5 rounded-full">
              {item.category}
            </span>
            <div className="flex items-center gap-1">
              <Star className={`w-3 h-3 ${item.avg_rating > 0 ? "fill-orange-400 text-orange-400" : "text-stone-300"}`} />
              <span className="text-xs font-medium text-stone-700">{item.avg_rating > 0 ? item.avg_rating.toFixed(1) : "0"}</span>
              <span className="text-xs text-stone-400">({item.review_count || 0})</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
